export default __webpack_public_path__ + "static/media/CloverMini3.cee166b6.png";